var map = {
	"./addDisposal.svg": 770,
	"./addDisposal1.svg": 771,
	"./addDisposalGroup.svg": 772,
	"./addFavor.svg": 773,
	"./addMonitor.svg": 774,
	"./addOpinion.svg": 775,
	"./delete.svg": 776,
	"./disposalDetail.svg": 777,
	"./feedback.svg": 778,
	"./removeDisposal.svg": 779,
	"./removeDisposal2.svg": 780,
	"./removeDisposalGroup.svg": 781,
	"./removeFavor.svg": 782,
	"./removeMonitor.svg": 783,
	"./removeOpinion.svg": 784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 269;